// extracted by mini-css-extract-plugin
module.exports = {"title":"Preview_title__1LSJ6","channel":"Preview_channel__2B7u3","root":"Preview_root___KsWJ","preview":"Preview_preview__3kHYR","head":"Preview_head__3CvYo"};